<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item :to="{ path: 'goodsCatalog' }">物料目录</el-breadcrumb-item>
      <el-breadcrumb-item>添加物料目录</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-form ref="form" :model="form" label-width="160px">
        <el-form-item label="物料编码" :required="true">
          <el-input v-model="form.gcode" maxlength="100" placeholder="请输入物料编码" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="物料名称" :required="true">
          <el-input v-model="form.title" placeholder="请输入物料名称" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="物料描述/规格">
          <el-input type="textarea" v-model="form.remark" maxlength="250" show-word-limit></el-input>
        </el-form-item>
        <el-form ref="form" inline :model="form" label-width="160px">
          <el-form-item label="单位" :required="true">
            <el-input v-model="form.unit" maxlength="50" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <el-form-item label="采购员" :required="true" v-if="showBtn<1">
          <el-select v-model="form.buyer" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in buyer"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" v-if="showBtn<1||showBtn==3">
          <el-button @click="saveGoods">保存</el-button>
        </el-form-item>
    </el-form>
  </div>
</el-card>
</template>
<script>
import goodsFunction from "@/api/goods"
import userFunction from "@/api/user"
export default {
  data() {
    return {
      showBtn:sessionStorage.getItem('roleid'),
      buyer:[],
      form:{
        gcode:'',
        title:'',
        keywords:'',
        remark:'',
        price:0.00,
        unit:'',
        scale:'',
        buyer:'',
        validityTime:'',
        status:1,
        examine:0,
        vcode:sessionStorage.getItem('token'),
      },
    };
  },
  methods:{
    saveGoods(){
      if(!this.form.gcode){
        this.$message.error('物料编码不能为空');
        return false;
      }
      if(!this.form.title){
        this.$message.error('物料名称不能为空');
        return false;
      }
      goodsFunction.saveGoodsCatalog(this.form,this).then(res=>{
        this.$router.push('/home/goodsCatalog')
      })
    },
    getBuyer(){
      userFunction.getBuyer({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.buyer = res
      })
    },
  },
  mounted () {
    this.getBuyer()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/goods/addGoodsCatalog.vue